import { Component, OnInit } from '@angular/core';
import {Subject} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {IWorkflowCollectionState} from '../../../workflow/store/workflow.reducer';
import {ParticleService} from '@core/services/particle.service';
import {Router} from '@angular/router';
import {getCurrentBasket, ParticleState} from '@shared/store/reducers/particle.reduer';
import {TimeZoneService} from '@core/services/time-zone.service';
import {getCurrentProject, ProjectState} from '../../../projects/store/reducers/projects.reducer';
import {getWorkflowReducerState, isWorkflowCleanedUp} from '../../../workflow/store/workflow.selector';
import {takeUntil} from 'rxjs/operators';
import {Configuration} from '@shared/models/configuration';
import {CreateWorkflowAction} from '../../../workflow/store/workflow.actions';
import { Guid } from 'guid-typescript';
import {ProjectModel} from "../../../projects/models/projects.models";
import {QueryProvider} from "@shared/queries/query-provider";
import {SecurityState} from '@shared/store/reducers/security.reducer';
import {BasketModel} from '@shared/models/common.models';

@Component({
    standalone: false,
    selector: 'particle-arrangement-import',
  templateUrl: './arrangement-import.component.html',
  styleUrls: ['./arrangement-import.component.css']
})
export class ArrangementImportComponent implements OnInit {

  workflowTemplate: string;
  apiEndpointKey: string;
  workflowState$: any;
  cleanedUp$: any;
  unsubscribe$ = new Subject<void>();
  hasWorkflowId = false;
  workflowId: string;
  currentProjectId: string;
  currentBasket: BasketModel;
  constructor(private store: Store<IWorkflowCollectionState>,
              private particleService: ParticleService,
              private router: Router,
              private particleStore: Store<ParticleState>,
              private timeZoneService: TimeZoneService,
              private projectStore: Store<ProjectState>,
              private securitystore: Store<SecurityState>) {
    this.workflowId = Guid.create().toString();
    this.apiEndpointKey = 'Dac6Api';
    this.workflowTemplate = 'import-arrangement-workflow';
  }

  ngOnInit() {
    this.currentBasket = Configuration.getCurrentBasket();
    if(this.currentBasket){
      this.workflowTemplate = this.workflowTemplate + this.currentBasket.basketKey;
    }
    this.workflowState$ = this.store.pipe(select(getWorkflowReducerState, this.workflowId));
    this.workflowState$.pipe(takeUntil(this.unsubscribe$)).subscribe(state => {
      if (state) {
        console.log('workflow', state);
        this.cleanWorkflow();
      }

    });

    this.projectStore.pipe(select(getCurrentProject), takeUntil(this.unsubscribe$)).subscribe( (project: ProjectModel) => {
      if (project) {
        this.currentProjectId = project.ProjectId;
        this.createWorkflow();
      }
    });
  }

  private createWorkflow() {
    const url = `${Configuration.getConfig(this.apiEndpointKey)}Command/CreateWorkflow`;
    const action = new CreateWorkflowAction(url, this.workflowId, 'Import Arrangement', this.workflowTemplate);
    action.setParameters({
      'PROJECT_ID': this.currentProjectId,
      'ImportSampleExcelTemplateName': this.getImportSampleExcelTemplateName()
    });
    this.store.dispatch(action);
  }
  getImportSampleExcelTemplateName() {
    const basketCountry = this.currentBasket.id.split('-')[1];
    const excelName = 'Arrangement' + 'ImportSampleExcelTemplate-' + basketCountry + '.xlsx';
    return excelName;
  }

  cleanWorkflow() {
    this.cleanedUp$ = this.store.pipe(select(isWorkflowCleanedUp, this.workflowId));
    this.cleanedUp$.pipe(takeUntil(this.unsubscribe$)).pipe(takeUntil(this.unsubscribe$)).subscribe(state => {
      if (state === 'Finished' || state === 'Cancelled') {
        this.router.navigateByUrl('dac6-reporter/arrangement');
      }
    });
  }
  onGridCellValueChange($event) {
    console.log('cell value change', $event);
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
